import { zeroFill } from './zero-fill';

export function secondsHumanize(inputSeconds: number): string {
  if (!inputSeconds) {
    return '00:00';
  }

  const hours = Math.floor(inputSeconds / 3600);
  const minutes = Math.floor((inputSeconds - hours * 3600) / 60);
  const seconds = Math.floor(inputSeconds - hours * 3600 - minutes * 60);

  if (hours > 0) {
    return `${hours}:${zeroFill(minutes, 2)}:${zeroFill(seconds, 2)}`;
  }

  return `${zeroFill(minutes, 2)}:${zeroFill(seconds, 2)}`;
}
